/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { startTransition, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { NUMBER } from "../../../constants/app-constants";
import { bifrost } from "../../../utils/get-bifrost-instance";
import { sendOTP, verifyOtp, login, logout, getUserDetails } from "./actions";
import { setMobile, markUnauthorized, saveUserCibilConsent, getBifrostProfileDetails, exchangeAndAuthenticateWithBifrost, setBifrostTokens} from "../../configuration/actions";
import { sendCustomGaEvents } from "../../../tracking";
import { LOGIN_PAGE } from "../../../constants/login-constants";

// eslint-disable-next-line max-params, no-unused-vars
export default function withOtp(Component, ignoredStates = [], disableLoadingOnVerification = true, options = {}) {
    const { isCustomLogin = false, skipLegacyResolve = false } = options || {};
    const OtpComponent = (props) => {

        const {
            postInspectionDiy,
            isLoggedIn,
            mobile,
            sendOTPConnect,
            setMobileConnect,
            verifyOtpConnect,
            getProfileDetailsConnect,
            logoutConnect,
            markUnauthorizedConnect,
            saveUserCibilConsentConnect = () => {},
            currentPageType = "",
            secureToken,
            exchangeAndAuthenticateWithBifrostConnect = () => {},
            setBifrostTokensConnect = () => {}
        } = props;

        const { carDetails } = postInspectionDiy || {};
        const { phone } = carDetails || {};
        const [otp, setOtp] = useState("");
        const [showOtpField, setShowOtpField] = useState(false);
        const [isLoading, setIsLoading] = useState(false);
        const [errorMessage, setErrorMessage] = useState("");
        const [isAutoFilledOTP, setIsAutoFilledOTP] = useState(false);
        const [otpLength, setOtpLength] = useState(bifrost.getOtpLength());
        const [userMobile, setUserMobile] = useState(mobile || "");

        const onMobileNumberChange = ({ target: { value }}) => {
            setUserMobile(value);
            setMobileConnect(value);
        };

        const resetErrorMessage = () => {
            setErrorMessage("");
        };

        const logoutUser = (logoutOptions) => {
            const {logoutCallback = () => {}} = logoutOptions || {};
            logoutConnect(secureToken).then(() => {
                markUnauthorizedConnect();
                // Reset OTP-related states after logout
                setShowOtpField(false);
                setOtp("");
                setErrorMessage("");
                setIsLoading(false);
                logoutCallback();
            });
        };

        const logoutUserPromisify = () => {
            return new Promise((resolve, reject) => {
                logoutConnect(secureToken).then(() => {
                    markUnauthorizedConnect();
                    // Reset OTP-related states after logout
                    setShowOtpField(false);
                    setOtp("");
                    setErrorMessage("");
                    setIsLoading(false);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        };

        const sendOtp = (number) => {
            setOtp("");
            resetErrorMessage();
            sendOTPConnect(number, true)
                .then((response) => {
                    setOtpLength(response?.data?.otp_len || bifrost.getOtpLength());
                    setShowOtpField(true);
                    setIsLoading(false);
                })
                .catch((error) => {
                    const errorCode = error?.error || error?.message || "";
                    setErrorMessage(errorCode);
                    setShowOtpField(false);
                    setIsLoading(false);
                });
        };

        const isLoginRequired = () => {
            return !isLoggedIn;
        };

        const getOtpHandler = (mobileNumber = "") => {
            setUserMobile(mobileNumber || mobile);
            setIsLoading(true);
            sendOtp(mobileNumber || mobile);
            startTransition(() => {
                setIsAutoFilledOTP(true);
            });
        };

        const fetchProfileDetails = (resolve, overrideCustomLogin = false) => {
            if (isCustomLogin && !overrideCustomLogin) {
                resolve();
            } else {
                getProfileDetailsConnect().then(async (profileResponse) => {
                    const { data: { data: { user } } } = profileResponse;
                    const { user_id: userId = "", token: userToken} = user || {};
                    await saveUserCibilConsentConnect({ userId, source: "mSite", secureToken: userToken }).catch(() => "");
                    if (disableLoadingOnVerification) setIsLoading(false);
                    resolve(user);
                }).catch(() => {
                    resolve();
                    if (disableLoadingOnVerification) setIsLoading(false);
                });
            }
        };

        const handleUserLogin = (mobileNumber = "", otpVerificationFn = verifyOtpConnect, extraParams = {}) => {
            resetErrorMessage();
            setIsLoading(true);
            const params = {
                phone_number: mobileNumber || mobile,
                otp,
                ...extraParams
            };
            return new Promise((resolve, reject) => {
                otpVerificationFn(params, true).then(async (response) => {

                    sendCustomGaEvents({
                        event: "login_done",
                        eventAction: "login_done",
                        eventLabel: LOGIN_PAGE[currentPageType] || currentPageType
                    });

                    if (isCustomLogin) {
                        const token = response?.token;
                        if (token) {
                            // Save bifrost tokens to Redux state
                            setBifrostTokensConnect({
                                secureToken: token,
                                refreshToken: response?.refresh_token || "",
                                sessionId: response?.session_id || ""
                            });
                            await getProfileDetailsConnect(token);
                        }
                        if (disableLoadingOnVerification) setIsLoading(false);
                        resolve(response);
                        return;
                    }

                    // if (response?.error) {
                    //     const { error: { error_message: errormessage } } = response;

                    try {
                        const responseData = response.data || {};
                        const loginUrl = ((response.data || {}).login_url || "");
                        if (loginUrl) {
                            const accessToken = loginUrl.split("access-token=")[1] || responseData["access-token"];
                            if (!accessToken) {
                                setIsLoading(false);
                                return;
                            }

                            const authResult = await exchangeAndAuthenticateWithBifrostConnect(accessToken);
                            const bifrostToken = authResult?.bifrostToken;
                            if (!isCustomLogin && bifrostToken) {
                                await saveUserCibilConsentConnect({
                                    source: "mSite",
                                    secureToken: bifrostToken
                                }).catch(() => "");
                            }

                            if (disableLoadingOnVerification) setIsLoading(false);

                            resolve({
                                token: bifrostToken,
                                profileResponse: authResult?.profileResponse
                            });
                        } else {
                            const token = response?.token;
                            if (token) {
                                // Save bifrost tokens to Redux state
                                setBifrostTokensConnect({
                                    secureToken: token,
                                    refreshToken: response?.refresh_token || "",
                                    sessionId: response?.session_id || ""
                                });
                                await getProfileDetailsConnect(token);
                            }
                            if (disableLoadingOnVerification) setIsLoading(false);

                            if (!skipLegacyResolve) {
                                resolve(response);
                            }
                        }

                    } catch (error) {
                        setIsLoading(false);
                        reject(error);
                    }

                }).catch(error => {
                    const errorCode = (error &&
                        error.errors &&
                        error.errors[0] &&
                        error.errors[0].error) || (error && error.message) || "";
                    setErrorMessage(errorCode);
                    reject(error);
                    setOtp("");
                    setIsLoading(false);
                });
            });
        };

        const onOtpChange = (number) => {
            if (number && number.length === NUMBER.ONE) resetErrorMessage();
            setOtp(number);
        };

        const resendOTPHandler = () => {
            sendOtp(userMobile || mobile);
        };

        return (
            <Component
                {...props}
                otp={otp}
                phoneNumber={mobile || phone}
                showOtpField={showOtpField}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isAutoFilledOTP={isAutoFilledOTP}
                onMobileNumberChange={onMobileNumberChange}
                isLoginRequired={isLoginRequired}
                getOtpHandler={getOtpHandler}
                onOtpVerify={handleUserLogin}
                onOtpChange={onOtpChange}
                resendOTPHandler={resendOTPHandler}
                setShowOtpField={setShowOtpField}
                setOtp={setOtp}
                setIsAutoFilledOTP={setIsAutoFilledOTP}
                logoutUser={logoutUser}
                logoutUserPromisify={logoutUserPromisify}
                setIsLoading={setIsLoading}
                fetchProfileDetails={fetchProfileDetails}
                resetErrorMessage={resetErrorMessage}
                getProfileDetailsConnect={getProfileDetailsConnect}
                setMobileConnect={setMobileConnect}
                verifyOtpConnect={verifyOtpConnect}
                otpLength={otpLength}
            />
        );
    };

    OtpComponent.propTypes = {
        isLoggedIn: PropTypes.bool,
        mobile: PropTypes.string,
        postInspectionDiy: PropTypes.object,
        loginConnect: PropTypes.func,
        setMobileConnect: PropTypes.func,
        verifyOtpConnect: PropTypes.func,
        sendOTPConnect: PropTypes.func,
        getProfileDetailsConnect: PropTypes.func,
        logoutConnect: PropTypes.func,
        markUnauthorizedConnect: PropTypes.func,
        saveUserCibilConsentConnect: PropTypes.func,
        currentPageType: PropTypes.string,
        onSuccess: PropTypes.func,
        secureToken: PropTypes.string,
        exchangeAndAuthenticateWithBifrostConnect: PropTypes.func,
        setBifrostTokensConnect: PropTypes.func
    };

    const mapStateToProps = ({
        user: { isLoggedIn, mobile, currentPageType, secureToken },
        postInspectionDiy
    }) => {
        return {
            isLoggedIn,
            mobile,
            postInspectionDiy,
            currentPageType,
            secureToken
        };
    };

    const mapDispatchToProps = (dispatch) => bindActionCreators({
        loginConnect: login,
        setMobileConnect: setMobile,
        verifyOtpConnect: verifyOtp,
        sendOTPConnect: sendOTP,
        getProfileDetailsConnect: getBifrostProfileDetails,
        logoutConnect: logout,
        markUnauthorizedConnect: markUnauthorized,
        saveUserCibilConsentConnect: saveUserCibilConsent,
        getUserDetailsConnect: getUserDetails,
        exchangeAndAuthenticateWithBifrostConnect: exchangeAndAuthenticateWithBifrost,
        setBifrostTokensConnect: setBifrostTokens
    }, dispatch);
    return connect(mapStateToProps, mapDispatchToProps)(OtpComponent);
}
